import { render, staticRenderFns } from "./SemiannualReview.vue?vue&type=template&id=89ea326a&scoped=true"
import script from "./SemiannualReview.vue?vue&type=script&lang=js"
export * from "./SemiannualReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ea326a",
  null
  
)

export default component.exports